export default __webpack_public_path__ + "static/media/MainIcon2.58c2715a.svg";